function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPc06 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "76.919 61.014 81.444 58.87 91.966 64.131 92.281 68.08",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.27216,71.86984A87.9918,87.9918,0,0,0,66.534,58.12358",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.98269,57.892A98.40065,98.40065,0,0,0,2.844,66.39509",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5397,
    cy: 71.907,
    rx: 3.15567,
    ry: 7.82189,
    transform: "translate(-15.29958 120.38065) rotate(-66.28087)",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1713,77.93629c-1.07357,2.44344-6.85365,2.267-12.91017-.394s-10.096-6.799-9.02242-9.24248",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.74824,
    cy: 69.50018,
    rx: 7.32859,
    ry: 2.95665,
    transform: "translate(-15.87095 4.89573) rotate(-13.49884)",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.09748,67.97378c.58369,2.43149-3.82889,5.57547-9.85578,7.02227S2.85586,75.6446,2.27216,73.21311",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.30586,
    cy: 79.21825,
    rx: 2.95665,
    ry: 7.32859,
    transform: "matrix(0.02118, -0.99978, 0.99978, 0.02118, -31.91763, 125.83562)",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.67065,80.62422c-.053,2.5-5.11933,4.42026-11.31606,4.289s-11.17724-2.26433-11.12428-4.76434",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.70534,
    y1: 62.71036,
    x2: 60.10077,
    y2: 66.28616,
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.38855,33.76619a21.28446,21.28446,0,0,0,18.74454-.89735",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.36651,53.30545c10.37731,5.18865,30.953,5.00973,40.43574-1.07352",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.26789,52.40571A10.1838,10.1838,0,0,1,60.222,62.40517a58.10428,58.10428,0,0,1-24.94517-.04157,10.13789,10.13789,0,0,1-7.7727-8.52683,10.02206,10.02206,0,0,1,.51065-4.82158c.06531-.17223.12471-.33252.196-.49286a42.92091,42.92091,0,0,1,4.5781-8.75247A58.2083,58.2083,0,0,1,37.367,33.79038c.74818-.861,1.48447-1.66261,2.19109-2.39891a10.18378,10.18378,0,0,1,13.7047-.99165q1.41616,1.13118,2.678,2.29206a48.80108,48.80108,0,0,1,10.7476,14.20941c.22564.46314.44534.90848.64721,1.35383A9.994,9.994,0,0,1,68.26789,52.40571Z",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.07431,
    y1: 60.57851,
    x2: 34.7134,
    y2: 68.44824,
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2541,67.702c-.07612.90434-2.28553,1.45668-4.93485,1.23368s-4.73531-1.13688-4.65919-2.04123c.04838-.57477.9585-1.00735,2.2956-1.18906a12.30024,12.30024,0,0,1,2.63925-.04462,13.20781,13.20781,0,0,1,1.85638.28584C64.15209,66.34009,65.31119,67.02372,65.2541,67.702Z",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.613,69.79513c-.07612.90434-2.28552,1.45668-4.93484,1.23368s-4.73531-1.13688-4.65919-2.04123c.04838-.57477.9585-1.00735,2.2956-1.18906a12.30022,12.30022,0,0,1,2.63925-.04462,13.20826,13.20826,0,0,1,1.85638.28584C38.511,68.43324,39.6701,69.11687,39.613,69.79513Z",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.4109,
    cy: 46.04747,
    rx: 5.24823,
    ry: 6.05997,
    transform: "translate(-2.37228 2.57566) rotate(-3.03599)",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.151,45.56141c-.85131,2.83777-3.2366,4.64011-5.315,4.01119a3.28539,3.28539,0,0,1-1.9174-1.63363,43.03351,43.03351,0,0,1,4.57874-8.751,3.88252,3.88252,0,0,1,.4295.092C36.0053,39.90123,37.01,42.716,36.151,45.56141Z",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3452,39.03537a2.90623,2.90623,0,0,0-.7593.12272c-2.08613.62123-3.08318,3.436-2.23186,6.28141.85133,2.83776,3.23658,4.64012,5.32272,4.01121A3.65725,3.65725,0,0,0,66.04667,46.613v-.00767",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1875820354245592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.56518,31.79031a5.55248,5.55248,0,0,0,4.7-4.70024h.11235a5.55248,5.55248,0,0,0,4.7,4.70024v.11232a5.55246,5.55246,0,0,0-4.7,4.69982h-.11243a5.55245,5.55245,0,0,0-4.7-4.69982Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.54889,20.75182a3.22682,3.22682,0,0,0,2.73139-2.73153h.0653a3.22682,3.22682,0,0,0,2.7314,2.73153v.06527a3.22681,3.22681,0,0,0-2.73138,2.73129h-.06534a3.22678,3.22678,0,0,0-2.73137-2.73129Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.10578,36.94241a2.00429,2.00429,0,0,0,1.69656-1.69664h.04055a2.00429,2.00429,0,0,0,1.69656,1.69664V36.983a2.00425,2.00425,0,0,0-1.69654,1.69649h-.04059A2.00426,2.00426,0,0,0,73.10578,36.983Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPc06);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PC06.51bfceb9fb6b5078d758d20e89b59227.svg";